module.exports = __webpack_public_path__ + "img/qy1.2a887947.jpg";